export default __webpack_public_path__ + "static/media/exploded-view_labels.c046e93b.png";